import {
  Grid,
  styled,
  Typography,
  Theme,
  useTheme,
  Icon,
} from '@yuno/design-system-web'
import { IInstructions } from '../../interfaces/connection.interfaces'
import { ConnectionSetupInstruction } from '../connection-setup-instructions/connection-setup-instruction'
import { useTranslation } from 'react-i18next'

export const AlertStyled = styled('div')<{ theme?: Theme }>(({ theme }) => ({
  borderRadius: 4,
  padding: 16,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.palette.pastel.brand,
  margin: '20px 0 40px 0',
}))

interface IConnectionInstructionsAlert {
  instructions?: Array<IInstructions>
}

export const ConnectionInstructionsAlert = ({
  instructions,
}: IConnectionInstructionsAlert) => {
  const { t } = useTranslation()
  const { palette }: Theme = useTheme()
  return (
    <AlertStyled>
      <Grid container>
        <Grid item xs={12}>
          <Grid container alignItems="center">
            <Grid item>
              <Icon
                name="Info"
                color={palette.vivid.brand}
                size="13px"
                weight="fill"
              />
            </Grid>
            <Grid item ml={1}>
              <Typography
                variant="body2"
                fontWeight="700"
                lineHeight="16px"
                color={palette.vivid.brand}
              >
                {t('howObtainCredentials')}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} mt={1}>
          <Typography variant="caption" color={palette.vivid.brand}>
            <ConnectionSetupInstruction
              credentials={true}
              instrunctions={instructions}
              instrunctionsType="link"
            />
          </Typography>
        </Grid>
      </Grid>
    </AlertStyled>
  )
}
